export default "__VITE_ASSET__6adf9ce6__"